(function () {
  function initRoot(root) {
    var dataEl = root.querySelector('[data-sl-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (e) { variants = []; }

    function showSlide(index) {
      root.querySelectorAll('.sl-g-slide').forEach(function (s) {
        s.style.display = (s.getAttribute('data-sl-slide') == index) ? 'block' : 'none';
      });
    }

    function updateVariant() {
      var selected = {};
      root.querySelectorAll('.sl-opt-row input[type=radio]:checked').forEach(function (input) {
        selected[input.getAttribute('data-opt-index')] = input.value;
      });
      var match = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var ok = true;
        for (var key in selected) {
          if (v.options[parseInt(key, 10) - 1] !== selected[key]) { ok = false; break; }
        }
        if (ok) { match = v; break; }
      }
      if (!match) return;
      var variantInput = root.querySelector('.sl-js-variant-id');
      if (variantInput) variantInput.value = match.id;
      var priceEl = root.querySelector('.sl-js-price');
      var stickyPriceEl = root.querySelector('.sl-js-sticky-price');
      var submitBtns = root.querySelectorAll('.sl-js-submit');
      submitBtns.forEach(function (btn) {
        if (match.available) {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-label-available') || 'Dodaj do koszyka';
        } else {
          btn.disabled = true;
          btn.textContent = btn.getAttribute('data-label-unavailable') || 'Niedostępne';
        }
      });
      if (match.priceText) {
        if (priceEl) priceEl.textContent = match.priceText;
        if (stickyPriceEl) stickyPriceEl.textContent = match.priceText;
      }
      var saveEl = root.querySelector('.sl-js-save');
      if (saveEl) {
        if (match.compareText) {
          saveEl.style.display = '';
          saveEl.textContent = (saveEl.getAttribute('data-label-save') || 'oszczędzasz') + ' ' + match.compareText;
        } else {
          saveEl.style.display = 'none';
        }
      }
    }

    root.querySelectorAll('.sl-g-radio').forEach(function (radio) {
      radio.addEventListener('change', function () { showSlide(this.getAttribute('data-sl-index')); });
    });

    root.querySelectorAll('.sl-opt-row input[type=radio]').forEach(function (radio) {
      radio.addEventListener('change', updateVariant);
    });
  }

  document.querySelectorAll('[data-sl-pdp]').forEach(initRoot);
})();
